export default __webpack_public_path__ + "static/media/ktp-correct.e4e042a5.png";